import React, { useState, useEffect, useContext, useRef } from "react";
import user from "../assets/media/images/user2.png";
import { AppContext } from "../AppContextProvider";
import CircleProgressComponent from "../components/graph/CircleProgressComponent";
import { twinModalParams } from "../data/SampleData";
import moment from "moment";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBRow,
  MDBCol,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
} from "mdb-react-ui-kit";

export default function CategoriesModal(props) {
  const context = useContext(AppContext);
  const [isDark, setIsDark] = useState(true);
  const [activeTab, setActiveTab] = useState("");
  const [categoriesMap, setCategoriesMap] = useState([]);
  const [categoriesArray, setCategoriesArray] = useState([]);
  const [process1, setProcess1] = useState(0);
  const [process2, setProcess2] = useState(0);
  const [process3, setProcess3] = useState(0);
  const [process4, setProcess4] = useState(0);
  const [process5, setProcess5] = useState(0);
  const [process6, setProcess6] = useState(0);
  const [process7, setProcess7] = useState(0);
  const [process8, setProcess8] = useState(0);

  const amazonDump = JSON.parse(sessionStorage.getItem("isAmazonDump"));

  useEffect(() => {
    const getProgressFromStats = (cid) => {
      const catStats = twinModalParams.categories?.[cid];
      if (catStats) {
        return Math.round((catStats.usedData / catStats.maxData) * 100);
      }
      return 0;
    };

    if (props.modalParam && Array.isArray(props.modalParam)) {
      const getChildrenCount = (cid) => {
        const node = props.modalParam.find((k) => k.cid === cid);
        return node ? node.childrenCount : 0;
      };
      
      const calcProgress = (cid) => {
        const childCount = getChildrenCount(cid);
        if (childCount > 0) {
          const catStats = twinModalParams.categories?.[cid];
          const maxData = catStats?.maxData || 10000;
          return Math.round((childCount / maxData) * 100);
        }
        return getProgressFromStats(cid);
      };
      
      setProcess1(Math.max(calcProgress(1), 1));
      setProcess2(Math.max(calcProgress(2), 1));
      setProcess3(Math.max(calcProgress(3), 1));
      setProcess4(Math.max(calcProgress(4), 1));
      setProcess5(Math.max(calcProgress(5), 1));
      setProcess6(Math.max(calcProgress(6), 1));
      setProcess7(Math.max(calcProgress(7), 1));
      setProcess8(5);

      const defaultCategories = [
        { cid: 1, label: 'Identity' },
        { cid: 2, label: 'Health' },
        { cid: 3, label: 'Social' },
        { cid: 4, label: 'Location' },
        { cid: 5, label: 'Finance' },
        { cid: 6, label: 'Career' },
        { cid: 7, label: 'Communication' },
        { cid: 8, label: 'Devices' },
      ];

      const existingCategories = props.modalParam
        .filter((k) => k.level === 1)
        .filter((k) => k.label !== "dataOwnerFiles" && k.label !== "User Files")
        .filter((k) => k.cid >= 1 && k.cid <= 8);

      const mergedCategories = defaultCategories.map(defaultCat => {
        const existing = existingCategories.find(e => e.cid === defaultCat.cid);
        return existing ? { filter: existing.label, category: existing.label, cid: existing.cid } 
                        : { filter: defaultCat.label, category: defaultCat.label, cid: defaultCat.cid };
      });

      setCategoriesMap(mergedCategories.slice(0, 8));
    }
  }, [props.modalParam]);

  useEffect(() => {
    if (props.modalParam && categoriesMap.length > 0) {
      setCategoriesArray([
        {
          name: categoriesMap.length > 0 ? categoriesMap[0].filter : "n.d.",
          process: process1,
          primaryColor:
            categoriesMap.length > 0
              ? isDark
                ? ["#ffb8e0", "#3c002b"]
                : ["#ffe5f4", "#770059"]
              : isDark
                ? ["#1f2233", "#1f2233"]
                : ["#f1f2f6", "#f1f2f6"],
          color: categoriesMap.length > 0 ? "var(--nc-340-5)" : "var(--background-brand-primary-alt)",
          background: categoriesMap.length > 0 ? "var(--nc-340-10)" : "var(--background-brand-maxi-hover)",
        },
        {
          name: categoriesMap.length > 1 ? categoriesMap[1].filter : "n.d.",
          process: process2,
          primaryColor:
            categoriesMap.length > 1
              ? isDark
                ? ["#ffb693", "#351000"]
                : ["#ffe7db", "#6a2800"]
              : isDark
                ? ["#1f2233", "#1f2233"]
                : ["#f1f2f6", "#f1f2f6"],
          color: categoriesMap.length > 1 ? "var(--nc-020-5)" : "var(--background-brand-primary-alt)",
          background: categoriesMap.length > 1 ? "var(--nc-020-10)" : "var(--background-brand-maxi-hover)",
        },
        {
          name: categoriesMap.length > 2 ? categoriesMap[2].filter : "n.d.",
          process: process3,
          primaryColor:
            categoriesMap.length > 2
              ? isDark
                ? ["#b7f732", "#131f00"]
                : ["#e1fea5", "#324800"]
              : isDark
                ? ["#1f2233", "#1f2233"]
                : ["#f1f2f6", "#f1f2f6"],
          color: categoriesMap.length > 2 ? "var(--nc-080-5)" : "var(--background-brand-primary-alt)",
          background: categoriesMap.length > 2 ? "var(--nc-080-10)" : "var(--background-brand-maxi-hover)",
        },
        {
          name: categoriesMap.length > 3 ? categoriesMap[3].filter : "n.d.",
          process: process4,
          primaryColor:
            categoriesMap.length > 3
              ? isDark
                ? ["#77f875", "#002103"]
                : ["#cdffcc", "#004d0c"]
              : isDark
                ? ["#1f2233", "#1f2233"]
                : ["#f1f2f6", "#f1f2f6"],
          color: categoriesMap.length > 3 ? "var(--nc-120-5)" : "var(--background-brand-primary-alt)",
          background: categoriesMap.length > 3 ? "var(--nc-120-10)" : "var(--background-brand-maxi-hover)",
        },
        {
          name: categoriesMap.length > 4 ? categoriesMap[4].filter : "n.d.",
          process: process5,
          primaryColor:
            categoriesMap.length > 4
              ? isDark
                ? ["#3affb2", "#002012"]
                : ["#c7ffe9", "#004b30"]
              : isDark
                ? ["#1f2233", "#1f2233"]
                : ["#f1f2f6", "#f1f2f6"],
          color: categoriesMap.length > 4 ? "var(--nc-160-5)" : "var(--background-brand-primary-alt)",
          background: categoriesMap.length > 4 ? "var(--nc-160-10)" : "var(--background-brand-maxi-hover)",
        },
        {
          name: categoriesMap.length > 5 ? categoriesMap[5].filter : "n.d.",
          process: process6,
          primaryColor:
            categoriesMap.length > 5
              ? isDark
                ? ["#71d1ff", "#001d2e"]
                : ["#cceeff", "#00405d"]
              : isDark
                ? ["#1f2233", "#1f2233"]
                : ["#f1f2f6", "#f1f2f6"],
          color: categoriesMap.length > 5 ? "var(--nc-200-5)" : "var(--background-brand-primary-alt)",
          background: categoriesMap.length > 5 ? "var(--nc-200-10)" : "var(--background-brand-maxi-hover)",
        },
        {
          name: categoriesMap.length > 6 ? categoriesMap[6].filter : "n.d.",
          process: process7,
          primaryColor:
            categoriesMap.length > 6
              ? isDark
                ? ["#bdbdff", "#130a66"]
                : ["#e5e5ff", "#2118a5"]
              : isDark
                ? ["#1f2233", "#1f2233"]
                : ["#f1f2f6", "#f1f2f6"],
          color: categoriesMap.length > 6 ? "var(--nc-240-5)" : "var(--background-brand-primary-alt)",
          background: categoriesMap.length > 6 ? "var(--nc-240-10)" : "var(--background-brand-maxi-hover)",
        },
        {
          name: categoriesMap.length > 7 ? categoriesMap[7].filter : "n.d.",
          process: process8,
          primaryColor:
            categoriesMap.length > 7
              ? isDark
                ? ["#e9b8ff", "#310049"]
                : ["#f7e5ff", "#63008e"]
              : isDark
                ? ["#1f2233", "#1f2233"]
                : ["#f1f2f6", "#f1f2f6"],
          color: categoriesMap.length > 7 ? "var(--nc-280-5)" : "var(--background-brand-primary-alt)",
          background: categoriesMap.length > 7 ? "var(--nc-280-10)" : "var(--background-brand-maxi-hover)",
        },
      ]);
    }
  }, [props.modalParam, categoriesMap]);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="catgories-modal">
        <MDBModalDialog centered size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <div className="title-text">Digital twin dashboard</div>
              <button
                type="button"
                className="button subtle medium"
                onClick={() => props.hideModal()}
                style={{ minWidth: "unset" }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z"
                    fill="var(--text-brand-secondary)"
                  />
                </svg>
              </button>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="dwin-figur-col">
                {/*
                <div className="up-div">
                  <span className="image-title">Decentralized Storage Distribution</span>
                  <img className="human-image" src={twinModalParams.image} alt="worldmap" />
                  <span className="image-description">{"Location: " + twinModalParams.location}</span>
                  <span className="image-description">{"Number of Nodes: " + twinModalParams.numberOfNodes}</span>
                </div>
                */}
                <div className="down-div">
                  <div className="detail-title-text">
                    <span>User Storage Info</span>
                  </div>
                  <div className="detail-detail-text">
                    <span className="addres">Max. User Storage:</span>
                    <span className="value">{twinModalParams.maxUserStorage + " GByte"}</span>
                  </div>
                  <div className="detail-detail-text">
                    <span className="addres">Used Storage:</span>
                    <span className="value">{twinModalParams.usedStorage + " GByte"}</span>
                  </div>
                  <div className="detail-detail-text">
                    <span className="addres">Remaining Storage:</span>
                    <span className="value">
                      {twinModalParams.maxUserStorage - twinModalParams.usedStorage + " GByte"}
                    </span>
                  </div>
                  <div className="detail-detail-text">
                    <span className="addres">Files uploaded:</span>
                    <span className="value">{twinModalParams.filesUploaded}</span>
                  </div>
                  <div className="detail-detail-text">
                    <span className="addres">Dump Uploads:</span>
                    <span className="value">{twinModalParams.dumpUploads}</span>
                  </div>
                  <div className="detail-detail-text">
                    <span className="addres">MetaData Files:</span>
                    <span className="value">{twinModalParams.metaDataFiles?.toLocaleString()}</span>
                  </div>
                  <div className="detail-detail-text">
                    <span className="addres">Tagged/Untagged:</span>
                    <span className="value">{twinModalParams.taggedFiles?.toLocaleString()}/{twinModalParams.untaggedFiles?.toLocaleString()}</span>
                  </div>
                  <div className="detail-detail-text">
                    <span className="addres">Last Upload:</span>
                    <span className="value">
                      {moment(twinModalParams.lastUploadDate).locale("de").format("DD.MM.YYYY")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="category-symbole-col">
                {props.modalParam && categoriesArray.length > 0 && (
                  <>
                    {categoriesArray.map((k, n) => {
                      return (
                        <div key={n} className="category-symbole" onClick={() => setActiveTab(k.name)}>
                          <span className="category-name" style={{ color: k.color }}>
                            {k.name}
                          </span>
                          <div className="circle-div">
                            <CircleProgressComponent
                              percentage={Math.min(k.process, 100)}
                              primaryColor={k.primaryColor}
                              height={"70px"}
                              width={"70px"}
                              widthNumber={70}
                              strokeWidth={8}
                            />
                          </div>
                          <span className="category-process" style={{ color: k.color }}>
                            {k.process - 1 + "%"}
                          </span>
                          <div className="data-div" style={{ color: k.color }}>
                            <div className="data-tag" style={{ borderColor: k.color }}>
                              <span className="title">Max.Data</span>
                              <span className="details">{(twinModalParams.categories?.[n + 1]?.maxData || twinModalParams.category.maxData).toLocaleString()}</span>
                            </div>
                            <div className="data-tag" style={{ borderColor: k.color }}>
                              <span className="title">Used Data</span>
                              <span className="details">{(twinModalParams.categories?.[n + 1]?.usedData || twinModalParams.category.usedData).toLocaleString()}</span>
                            </div>
                            <div className="data-tag" style={{ borderColor: k.color }}>
                              <span className="title">Unused Data</span>
                              <span className="details">{(twinModalParams.categories?.[n + 1]?.unusedData || twinModalParams.category.unusedData).toLocaleString()}</span>
                            </div>
                            <div className="data-tag" style={{ borderColor: k.color }}>
                              <span className="title">Actualization Rate</span>
                              <span className="details">{twinModalParams.categories?.[n + 1]?.actRate || twinModalParams.category.actRate}</span>
                            </div>
                            <div className="data-tag" style={{ borderColor: k.color }}>
                              <span className="title">Tag Rate</span>
                              <span className="details">{twinModalParams.categories?.[n + 1]?.tagRate || twinModalParams.category.tagRate}</span>
                            </div>
                            <div className="data-tag" style={{ borderColor: k.color }}>
                              <span className="title">Linking Rate</span>
                              <span className="details">{twinModalParams.categories?.[n + 1]?.linkingRate || twinModalParams.category.linkingRate}</span>
                            </div>
                            <div className="data-tag2">
                              <span className="title2">Tier Level</span>
                              <span className="details2">{twinModalParams.categories?.[n + 1]?.tierLevel || twinModalParams.category.tierLevel}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <div className="actions-button-div">
                <button className="button subtle medium " onClick={() => props.hideModal()}>
                  <span className="text">Close</span>
                </button>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
